/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Router } from "@reach/router";
import Single from "../components/Single";
import Grid from "../components/Grid";

class Main extends Component {
  componentDidMount() {
    // Only initialize on first mount, not on hash navigation
    // Hash navigation is handled by App.js hashchange listener
    if (!!this.props.galleryName && this.props.galleries) {
      this.props.categoryChangeHandler(
        this.props.category,
        this.props.galleryName
      );
    } else if (this.props.path && this.props.path.indexOf("Search/") > -1) {
      if (this.props.query) {
        this.props.searchQuery(this.props.query);
      }
    } else if (this.props.category) {
      this.props.categoryChangeHandler(this.props.category);
    } else if (!this.props.category) {
      this.props.categoryChangeHandler("Home");
    }
    
    this.props.setLocation("Main");
    this.props.clearSearch();
  }

  render() {
    const { category, gallery, view } = this.props;
    const isHome = !category || category.toLowerCase() === "home";
    const isGallery = view === "gallery" && gallery && gallery.name;
    const categoryLabel = category
      ? category.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase())
      : "";
    const galleryLabel = gallery && gallery.name ? gallery.name : "";

    let title = "Aya Brackett Photography";
    let description = "Aya Brackett is an editorial, commercial and fine art photographer living in Oakland, CA.";
    if (isGallery) {
      const sameLabel = galleryLabel.toLowerCase() === categoryLabel.toLowerCase();
      title = sameLabel
        ? `${galleryLabel} | Aya Brackett`
        : `${galleryLabel} | ${categoryLabel} | Aya Brackett`;
      description = `${galleryLabel} — ${categoryLabel} photography by Aya Brackett.`;
    } else if (!isHome && categoryLabel) {
      title = `${categoryLabel} | Aya Brackett Photography`;
      description = `${categoryLabel} photography by Aya Brackett, editorial and commercial photographer based in Oakland, CA.`;
    }

    return (
      <div className="main">
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
        </Helmet>
        <div className="content">
          <div className={"gallery-container"}>
            {this.props.layout == "single" && this.props.view == "gallery" ? (
              <Single
                path="/photo"
                photo={this.props.photo}
                clickPicture={this.props.clickPicture}
                category={this.props.category}
                galleryLength={this.props.galleryLength}
                photoIndex={this.props.photoIndex}
                getAdjacentPhoto={this.props.getAdjacentPhoto}
              />
            ) : (
              <Grid
                path={`/`}
                galleries={this.props.galleries}
                category={this.props.category}
                view={this.props.view}
                galleryClick={this.props.galleryClick}
                gallery={this.props.gallery}
                photoClick={this.props.photoClick}
                galleryName={this.props.galleryName}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Main;
